import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=70a07a90&scoped=true"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a07a90",
  null
  
)

export default component.exports